//import { fetchAuthSession } from '@aws-amplify/auth';
import { AdminDeleteUserCommand, AdminDisableUserCommand, CognitoIdentityProviderClient, ListUsersCommand } from "@aws-sdk/client-cognito-identity-provider";
import { ContentCopy, Delete } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { Avatar, Box, Card, CardContent, Chip, Grid, IconButton, InputAdornment, Pagination, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api_service from '../../../network/api_callbacks';
import Loader from '../../../utility/Loader';
import { fetchAuthSession } from "aws-amplify/auth";
//import { Auth } from 'aws-amplify';

function ClientUserManagment({ userData, props }) {

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname;
    const state = location.state;
    const [loader, setLoader] = useState(false);
    const [deletedUsersList, setDeletedUsersList] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        getDeletedUsersList(page, search);
    }, [page]);

    //Get current credentials
    const getCurrentCredentials = async () => {
        const session = await fetchAuthSession({ bypassCache: true });
        const credentials = session?.credentials;

        if (!credentials) throw new Error("Unable to fetch AWS credentials");

        return {
            accessKeyId: credentials.accessKeyId,
            secretAccessKey: credentials.secretAccessKey,
            sessionToken: credentials.sessionToken,
        };
    };

    const cognitoClientProviderForAmplify = async () => {
        const creds = await getCurrentCredentials();
        const client = new CognitoIdentityProviderClient({
            region: 'ap-south-1',
            credentials: creds,
        });
        return client;
    };

    const removeFromAWSCognito = async (cognitoId) => {
        try {
            if (!cognitoId) throw new Error("Cognito ID is required");

            console.log("cognitoId : ", cognitoId)
            console.log("userData : ", userData)

            const client = await cognitoClientProviderForAmplify();
            if (!client) throw new Error("Failed to create Cognito client");

            // 1️⃣ Get All Users list
            const allUserslistCommand = new ListUsersCommand({
                UserPoolId: "ap-south-1_UL05sWBeG",
                // AttributesToGet: ['email'],
                // Limit: 60,
            });

            const AllUserslistResponse = await client.send(allUserslistCommand);

            console.log("✅ All Users List successfully", AllUserslistResponse);

            // 1️⃣ Get the actual username using the sub
            const listCommand = new ListUsersCommand({
                UserPoolId: "ap-south-1_UL05sWBeG",
                Filter: `sub = "${cognitoId}"`,
                Limit: 1,
                // AttributesToGet: ['email'],
                // Limit: 60,
            });

            const listResponse = await client.send(listCommand);

            console.log("✅ UserName successfully", listResponse);

            // if (!listResponse.Users || listResponse.Users.length === 0) {
            //     throw new Error(`User with sub ${cognitoId} not found`);
            // }

            const username = listResponse?.Users[0]?.Username;
            const Enabled = listResponse?.Users[0]?.Enabled;
            const UserStatus = listResponse?.Users[0]?.UserStatus;

            console.log("username : ", username);
            console.log("Enabled : ", Enabled);
            console.log("UserStatus : ", UserStatus);

            // 2️⃣ Delete the user using actual username
            const disableUserCommand = new AdminDisableUserCommand({
                UserPoolId: "ap-south-1_UL05sWBeG",
                Username: username,
            });

            // 2️⃣ Delete the user using actual username
            const deleteCommand = new AdminDeleteUserCommand({
                UserPoolId: "ap-south-1_UL05sWBeG",
                Username: username,
            });

            if (username) {
                console.log("username => ", true)
                const disableUserResponse = await client.send(disableUserCommand);
                const deleteResponse = await client.send(deleteCommand);
                console.log("✅ User disable successfully", disableUserResponse);
                console.log("✅ User deleted successfully", deleteResponse);
                console.log(`✅ User with cognitoId ${cognitoId} deleted successfully`);
                if (deleteResponse !== null) {
                    return true;
                }
                else {
                    return true;
                }
            }
            else {
                console.log("username => ", false)
                return true;
            }
        } catch (err) {
            console.error("❌ Failed to delete user:", err);
            toast.error(`AWS : ${err}`)
            return false;
        }
    }

    const getDeletedUsersList = async (currentPage = 1, searchTerm = '') => {
        setLoader(true);
        try {
            const params = { page: currentPage, limit: 10, search: `${searchTerm}` };
            const response = await api_service.getClientDeletedUsersList({ params });

            const status = response?.status;
            const resData = response?.data;
            const responseCode = resData?.responseCode;
            const listData = resData?.data;
            const usersListData = listData?.users;
            const paginationData = listData?.pagination;
            //const responseCode = response?.responseCode;
            const errorMsg = response?.error?.message;

            console.log('📘 getDeletedUsersList response :', response);
            console.log('📘 getDeletedUsersList status :', status);
            console.log('📘 getDeletedUsersList resData :', resData);
            console.log('📘 getDeletedUsersList usersListData :', usersListData);
            console.log('📘 getDeletedUsersList paginationData :', paginationData);
            //console.log('📘 getDeletedUsersList responseCode :', responseCode);
            console.log('📘 getDeletedUsersList errorMsg :', errorMsg);

            setDeletedUsersList(usersListData);
            setTotalPages(paginationData?.totalPages || 1);
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error('❌ Failed to fetch getDeletedUsersList:', error);
            setDeletedUsersList([]);
            setTotalPages(1);
        }
    };

    const handleSearch = () => {
        setPage(1); // reset page on new search
        getDeletedUsersList(1, search);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSearch();
    };

    const handleCopyReferral = (referralCode) => {
        navigator.clipboard.writeText(referralCode);
        toast.success('Referral code copied!');
    };

    const onDeleteUser = async (user) => {
        console.log("onDeleteUser : ", user)
        const cognitoId = user?.cognitoId;
        if (!window.confirm("Are you sure you want to delete this user?")) return
        try {
            setLoader(true);
            const result = await removeFromAWSCognito(cognitoId)
            console.log("result : ", result);
            if (result) {
                const response = await api_service.deleteClientUser({ userId: user?._id });
                const status = response?.status;
                const resData = response?.data;
                const responseCode = resData?.responseCode;
                const deletedData = resData?.data;
                const deletedUserData = resData?.data?.user;
                //const responseCode = response?.responseCode;
                const errorMsg = response?.error?.message;

                console.log('📘 getDeletedUsersList response :', response);
                console.log('📘 getDeletedUsersList status :', status);
                console.log('📘 getDeletedUsersList resData :', resData);
                //console.log('📘 getDeletedUsersList responseCode :', responseCode);
                console.log('📘 getDeletedUsersList errorMsg :', errorMsg);

                if (responseCode === 200) {
                    toast.success(`User ${deletedUserData?.userName} Successfully deleted from Rapchik.`)
                    getDeletedUsersList(page, search);
                }
                else {
                    toast.error("Rapchik Failed to delete user from backend.");
                }
            }
        }
        catch (error) {
            console.error("❌ onDeleteUser error:", error);
            toast.error(`Rapchik Failed: ${error.message}`);
        } finally {
            setLoader(false);
        }
    }

    const UserListItemCard = ({ adminUsers, onDeleteUser }) => {
        return (
            <Grid container spacing={2}>
                {adminUsers?.map((user) => (
                    <Grid item xs={12} md={6} lg={4} key={user?._id}>
                        <Card
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                boxShadow: 3,
                                position: 'relative', // important for absolute positioning
                                transition: '0.3s',
                                '&:hover': { boxShadow: 6, transform: 'translateY(-4px)' },
                            }}
                        >
                            {/* Delete Button */}
                            <IconButton
                                size="small"
                                sx={{
                                    position: 'absolute',
                                    top: 8,
                                    right: 8,
                                    color: 'error.main',
                                }}
                                onClick={() => onDeleteUser && onDeleteUser(user)}
                            >
                                <Delete fontSize="small" />
                            </IconButton>

                            <CardContent>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    {/* Profile Image */}
                                    <Avatar
                                        src={user?.profilePic}
                                        alt={user?.userName}
                                        sx={{ width: 60, height: 60, border: '2px solid #eee' }}
                                    />

                                    {/* User Info */}
                                    <Box>
                                        <Typography variant="h6" fontWeight={600}>
                                            {user?.userName}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary">
                                            ID: {user?._id}
                                        </Typography>

                                        <Typography variant="body2" color="text.secondary">
                                            AWS ID: {user?.cognitoId}
                                        </Typography>


                                        {/* Status Badges */}
                                        <Stack direction="row" spacing={1} mt={1}>
                                            <Chip
                                                label={user?.isActive ? 'Active' : 'Inactive'}
                                                color={user?.isActive ? 'success' : 'default'}
                                                size="small"
                                            />
                                            <Chip
                                                label={user?.isDeleted ? 'Deleted' : 'Active'}
                                                color={user?.isDeleted ? 'error' : 'success'}
                                                size="small"
                                            />
                                            <Chip
                                                label={user?.isSubscribed ? 'Subscribed' : 'Free User'}
                                                color={user?.isSubscribed ? 'info' : 'default'}
                                                size="small"
                                            />
                                        </Stack>
                                    </Box>
                                </Stack>

                                {/* Stats Section */}
                                <Box mt={2}>
                                    <Typography variant="body2">
                                        <strong>Rap Coins:</strong> {user?.rapCoinBalance}
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Total Points:</strong> {user?.totalPoints}
                                    </Typography>

                                    {/* Referral Code */}
                                    <Stack direction="row" alignItems="center" spacing={1} mt={0.5}>
                                        <Typography variant="body2" style={{ width: '100%' }}>
                                            <strong>Referral Code:</strong> {user?.referralCode}
                                        </Typography>
                                        <Tooltip title="Copy to clipboard">
                                            <ContentCopy
                                                fontSize="small"
                                                sx={{
                                                    cursor: 'pointer',
                                                    color: 'text.secondary',
                                                    '&:hover': { color: 'primary.main' },
                                                }}
                                                onClick={() => handleCopyReferral(user?.referralCode)}
                                            />
                                        </Tooltip>
                                    </Stack>
                                </Box>

                                {/* Dates */}
                                <Box mt={2}>
                                    <Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: '0.8rem' }}>
                                        Created At:{' '}
                                        <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                                            {new Date(user?.created_at).toLocaleString()}
                                        </span>
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: '0.8rem' }}>
                                        Last Login:{' '}
                                        <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                                            {new Date(user?.lastLoginAt).toLocaleString()}
                                        </span>
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        );
    }

    return (
        <>
            <div style={styles.container}>
                <Box sx={{ flex: 1, height: "100%", padding: 4, marginTop: 2 }}>

                    {/* Search Bar */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                        <TextField
                            label="Search Deleted Users"
                            variant="outlined"
                            size="small"
                            value={search}
                            onChange={(e) => setSearch(`${e.target.value}`)}
                            onKeyDown={handleKeyDown}
                            sx={{ width: 300 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleSearch}><SearchIcon /></IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Users List */}
                    {deletedUsersList && deletedUsersList.length > 0 ? (
                        <Box sx={{ p: 2 }}>
                            <UserListItemCard adminUsers={deletedUsersList} onDeleteUser={onDeleteUser} />
                        </Box>
                    ) : (
                        !loader && <Box sx={{ mt: 4, textAlign: 'center' }}>No deleted users found.</Box>
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                            <Pagination count={totalPages} page={page} onChange={(e, value) => setPage(value)} color="primary" />
                        </Box>
                    )}
                </Box>
            </div>
            {loader && <Loader />}
        </>
    );
}

// Simple inline styles
const styles = {
    container: {
        padding: '40px',
        textAlign: 'center',
    },
    title: {
        fontSize: '36px',
        marginBottom: '10px',
    },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => ({

});

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = (dispatch) => ({

});

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(ClientUserManagment);